
const queryObj = () => {
  let result = {}
  let keyValuePairs = window.location.href.slice(1).split('?')
  keyValuePairs.forEach(function (keyValuePair) {
    keyValuePair = keyValuePair.split('=')
    result[decodeURIComponent(keyValuePair[0])] = decodeURIComponent(keyValuePair[1]) || ''
  })
  return result
}
export default function () {
  this.getToken(queryObj().token)
  this.getTenantInfo(queryObj().token)
}



// WEBPACK FOOTER //
// ./src/app/auth/active/tenant/resources/mounted.js